package team.platforma.auth_data.di

import org.koin.dsl.bind
import org.koin.dsl.module
import team.platforma.auth_data.repository.AuthRepository
import team.platforma.auth_data.repository.AuthRepositoryImpl

val authDataModule = module {
    single { AuthRepositoryImpl(get()) }.bind<AuthRepository>()
}